import { render, staticRenderFns } from "./RecentBlog.vue?vue&type=template&id=7326db1f&"
import script from "./RecentBlog.vue?vue&type=script&lang=js&"
export * from "./RecentBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports